import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY in .env');
}

let authLockQueue = Promise.resolve();

const authLock = async (_name, _acquireTimeout, fn) => {
  const run = authLockQueue.then(fn, fn);
  authLockQueue = run.catch(() => {});
  return run;
};

const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    lock: authLock,
  },
});

export default supabase;
